<template>
  <div>
    <b-form-select
      :options="options"
      :value="value.selectValue"
      @input="updateValue"
    ></b-form-select>
    <b-form-checkbox
        switch
        size="lg"
        v-model="value.toggleValue"
        v-if="value.selectValue"
        class="mt-1"
    >
      <small>{{ toggleOption.text }}</small>
    </b-form-checkbox>
  </div>
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'SelectWithToggle',

  props: {
    data: {
      type: Object
    },

    value: {
      type: [Object],
      default () {
        return get(this.data, 'default') || {
          selectValue: null,
          toggleValue: false
        }
      }
    }
  },

  computed: {
    options () {
      let options = this.data.options.selectData

      if (get(this.data, 'allowEmpty') !== false) {
        options.unshift({
          value: null,
          text: get(this.data, 'emptyOption') || 'All'
        })
      }

      return options
    },

    toggleOption () {
      let toggleOptions = this.data.options.toggleData;
      let toggleValue = this.value.toggleValue
      let result = toggleOptions.filter(option => option.value === toggleValue)
      return result[0]
    }
  },

  methods: {
    updateValue (value) {
      //if(value === null) this.value.toggleValue = true;
      this.$emit('input', {
        selectValue: value,
        toggleValue: this.value.toggleValue
      })
    },

    getToggleValue (value, options) {
      let result = options.filter(option => option.value === value)
      return result.length ? result[0] : {}
    }
  }
}
</script>
